
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.md?watch=parent';
    export const demoIndex = {
  ids: ["flowdiagram-demo-common","flowdiagram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__FlowDiagram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.md?type=demo')
};